import { render, staticRenderFns } from "./goToTop.vue?vue&type=template&id=5cbc43d2"
import script from "./goToTop.vue?vue&type=script&lang=js"
export * from "./goToTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports